import React, { useEffect, useState } from 'react';
import ModalFormPieces from '../../components/forms/config/modal.form.pieces'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListPieces() {
  const [msgGet ,setMsgGet] = useState('');
  const [pieces,setPieces] = useState([]);
  const [vehicles,setVehicle] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getPieces()
    getVehicle()
  }, []);

  const createPiecesVehicle = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getPieces()
  };

  const editButton = (row) => {
    return (
      <ModalFormPieces
        vehicles={vehicles}
        title="Modificar Pieza"
        button_text="Editar"
        button_variant="outline-primary"
        pieceSelect={row.id}
        callback={createPiecesVehicle}
      ></ModalFormPieces>
    );
  };

  const getPieces = async()=>{
    const responsePieces = await get('/config/piecesvehicle/',{})
    if(responsePieces.success){
      setPieces(responsePieces.data);
    }else{
      setMsgGet(responsePieces.message)
    }       
  }

  const getVehicle = async()=>{
    const responseVehicle = await get('/catalog/vehicleclass/',{})
    if(responseVehicle.success){
      setVehicle(responseVehicle.data);
    }else{
      setMsgGet(responseVehicle.message)
    }       
  }


  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormPieces
        vehicles={vehicles}
        title="Crear Pieza"
        button_text="Crear Pieza"
        button_variant="primary"
        callback={createPiecesVehicle}
      ></ModalFormPieces>
      <ListTables
        data={pieces}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListPieces;
